let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("30y2M")).then(() => parcelRequire('4opkK'));